<div id="guest" class="registration container">
    <form #guestForm="ngForm" name="guestForm" (ngSubmit)="forward(guestForm)" novalidate appScrollToInvalid [panels]="panels"
        [ngClass]="{'form-complete': isFormCompleted}">

        <h1>{{ 'copy.label.GUEST.header' | copy | async }}</h1>
        <div id="rvs-text" *ngIf="isRegComplete">
          <a (click)="openContact()">{{"copy.label.GUEST.rvstext"|copy|async}}</a>
        </div>
        <section class="card">
        @if( addingGuestsIsAllowed ){
            <div class="card-header">
                <div class="card-title ms-0">
                    {{ 'copy.label.GUEST.label' | copy | async }}
                    <i class="fas fa-asterisk required"></i>
                </div>
            </div>
            <article>
                <div *ngIf="varTrack.Value === 'Benefit Advisor' || varTrack.Value==='Non-Benefit Advisor' || varTrack.Value==='Commonwealth Client' || attendee.PAXTypeNo == 23 || attendee.PAXTypeNo == 24" class="w-100" [innerHTML]='"copy.html.guestnote" | copy | async'></div>
                <mat-radio-group class="w-100" [(ngModel)]="attendee.$mtcHasGuestsAttending" [disabled]="isRegComplete" #hasGuest="ngModel" name="hasGuest" required>
                    <mat-radio-button [value]="true">Yes</mat-radio-button>
                    <mat-radio-button [value]="false">No</mat-radio-button>
                    <div class="w-100">
                        <small class="text-danger"><app-validation [object]="hasGuest" isRequired=true></app-validation></small>
                    </div>
                </mat-radio-group>
                
                <!-- <div *ngIf="attendee.PAXTypeNo == 50" class="w-100" [innerHTML]='"copy.html.commonGuestNote" | copy | async'></div> -->
                @if(attendee.$mtcHasGuestsAttending){
                    <div class="agreeCheckbox">
                        <p><strong>{{"copy.label.GUEST.GUESTFORM.guestAckHeading"|copy|async}}</strong></p>
                        <div class="checkboxFlexContainer">
                            <mat-checkbox name="guestAckCheckbox" [(ngModel)]="guestAck.Value"
                                [disabled]="isRegComplete" #guestAckCheckbox="ngModel" required>
                            </mat-checkbox>
                            <label class="required" [innerHTML]="'copy.label.GUEST.GUESTFORM.guestAck'|copy|async"></label>
                        </div>
                        <div class="w-100">
                            <small class="text-danger"><app-validation class="w-100" [object]="guestAckCheckbox" isRequired=true></app-validation></small>
                        </div>
                    </div>
                }
            </article>
        }
        @if( readyToDisplay && !addingGuestsIsAllowed){
            <article class="w-100 " [innerHTML]='"copy.html.noMoreGuests" | copy | async'></article>
        }
        </section>

        <div *ngIf="attendee.$mtcHasGuestsAttending">
            <h2 class="square">{{"copy.label.GUEST.GUESTFORM.heading"|copy|async}}</h2>
            <div *ngIf="varTrack.Value !== 'Sponsor' && pax !== 23 && pax !== 24 && pax !== 21 && pax !== 29 && pax !== 50" class="w-100" [innerHTML]='"copy.html.guestpdf" | copy | async'></div>
            <div *ngIf="pax === 27" class="w-100" [innerHTML]='"copy.html.guestpdfsponsorfc" | copy | async'></div>


        </div>

        <mat-accordion *ngIf="attendee.$mtcHasGuestsAttending" class="example-headers-align mb-4 w-100" multi>
            <mat-expansion-panel *ngFor="let guest of guests"
                [ngClass]="{'active': guest.$mtcIsSelected}"
                [expanded]="guest.$mtcIsSelected">

                <mat-expansion-panel-header class="w-100">
                    <mat-panel-title>
                        <strong>{{getDisplayName(guest)}}</strong>
                    </mat-panel-title>
                    <mat-panel-description>
                        &nbsp;
                        <mat-icon></mat-icon>
                    </mat-panel-description>
                </mat-expansion-panel-header>

                <div *ngIf="isRemoveGuestEnabled() && !isRegComplete" class="remove-guest text-right">
                    <button (click)="removeGuest(guest)" type="button"
                        class="btn btn-link">{{"copy.label.GUEST.GUESTFORM.remove"|copy|async}}</button>
                </div>

                <div class="w-100 required mt-5" *ngIf="attendee.PAXTypeNo !== 21 && attendee.PAXTypeNo !== 23 && attendee.PAXTypeNo !== 24 && attendee.PAXTypeNo !== 29">
                    <label class="w-100 floatLeft" for="PAXTypeNo"
                        aria-labelledby="PAXTypeNo">{{ 'copy.label.FEATURES.GUESTTYPE.heading' | copy | async }}</label>
                    <mat-radio-group [(ngModel)]="guest.PAXTypeNo" name="PAXTypeNo_{{guest.$mtcUUID}}" aria-label="PAXTypeNo"
                        #PAXTypeNo="ngModel" id="PAXTypeNo" matNativeControl required [disabled]="isRegComplete">
                        <mat-radio-button *ngFor="let op of guestTypes" [value]="op.value">{{op.display}}
                        </mat-radio-button>
                        <div class="w-100">
                            <small class="text-danger"><app-validation [object]="PAXTypeNo" isRequired=true></app-validation></small>
                        </div>
                    </mat-radio-group>
                </div>
                <div class="nameFields">
                    <mat-form-field class="firstNameInput">
                        <mat-label for="FirstName" aria-labelledby="FirstName" [ngClass]="{'active' : guest.FirstName}">
                            {{ 'copy.label.FEATURES.NAME.first' | copy | async }}</mat-label>
                        <input [disabled]="isRegComplete" matInput name="FirstName_{{guest.$mtcUUID}}" id="FirstName_{{guest.$mtcUUID}}" [attr.aria-label]="FirstName" type="text"
                             maxlength="25" pattern="^[A-Za-z\s\-\_'.]*$" [(ngModel)]="guest.FirstName"
                            #FirstName="ngModel" required />
                        <mat-error><app-validation [object]="FirstName" isRequired=true pattern="alpha"></app-validation></mat-error>
                    </mat-form-field>

                    <mat-form-field class="lastNameInput">
                        <mat-label for="LastName" aria-labelledby="LastName" [ngClass]="{'active' : guest.LastName}">
                            {{ 'copy.label.FEATURES.NAME.last' | copy | async }}</mat-label>
                        <input [disabled]="isRegComplete" matInput name="LastName_{{guest.$mtcUUID}}" id="LastName_{{guest.$mtcUUID}}" [attr.aria-label]="LastName" type="text"
                             maxlength="25" pattern="^[A-Za-z\s\-\_'.]*$" [(ngModel)]="guest.LastName"
                            #LastName="ngModel" required />
                        <mat-error><app-validation [object]="LastName" isRequired=true pattern="alpha"></app-validation></mat-error>
                    </mat-form-field>

                    <mat-form-field class="suffixInput">
                        <mat-label for="Suffix" aria-labelledby="Suffix">
                            {{ 'copy.label.FEATURES.NAME.suffix' | copy | async }}</mat-label>
                        <mat-select [disabled]="isRegComplete" name="Suffix_{{guest.$mtcUUID}}" id="Suffix_{{guest.$mtcUUID}}" aria-label="Suffix" [(ngModel)]="guest.Suffix"
                            matNativeControl>
                            <mat-option *ngFor="let obj of suffixList" [value]="obj.code">{{ obj.name }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <mat-form-field class="w-100">
                    <mat-label for="PreferredFirst" aria-labelledby="PreferredFirst"
                        [ngClass]="{'active' : guest.PreferredFirstName}">
                        {{ 'copy.label.FEATURES.NAME.preferredfirst' | copy | async }}</mat-label>
                    <input matInput name="PreferredFirst_{{guest.$mtcUUID}}" id="PreferredFirst_{{guest.$mtcUUID}}" aria-label="PreferredFirst" type="text"
                         maxlength="25" pattern="^[A-Za-z\s\-\_'.]*$" [(ngModel)]="guest.PreferredFirstName"
                        #PreferredFirst="ngModel" />
                    <mat-error><app-validation [object]="PreferredFirst" isRequired=true pattern="alpha"></app-validation></mat-error>
                </mat-form-field>

                <mat-form-field class="w-100">
                    <mat-label for="PreferredLast" aria-labelledby="PreferredLast"
                        [ngClass]="{'active' : guest.PreferredLastName}">
                        {{ 'copy.label.FEATURES.NAME.preferredlast' | copy | async }}</mat-label>
                    <input matInput name="PreferredLast_{{guest.$mtcUUID}}" id="PreferredLast_{{guest.$mtcUUID}}" [attr.aria-label]="PreferredLast"
                        type="text"  maxlength="25" pattern="^[A-Za-z\s\-\_'.]*$"
                        [(ngModel)]="guest.PreferredLastName" #PreferredLast="ngModel" />
                    <mat-error><app-validation [object]="PreferredLast" isRequired=true pattern="alpha"></app-validation></mat-error>
                </mat-form-field>
            <article class="pl-0" *ngIf="pax === 23 || pax === 24 || pax === 27">
                <h4>{{"copy.label.GUEST.GUESTFORM.checkboxheader"|copy|async}}</h4>
                <div class="agreeCheckbox">
                    <div class="checkboxFlexContainer">
                        <mat-checkbox name="hasGuestAgeAcknowledged_{{guest.$mtcUUID}}" [(ngModel)]="guest.$mtcHasGuestAgeAcknowledged"
                            [disabled]="isRegComplete" #hasGuestAgeAcknowledged="ngModel" required>
                        </mat-checkbox>
                        <label class="required">{{ 'copy.label.GUEST.acknowledge' | copy | async }}</label>
                    </div>
                    <div class="w-100">
                        <small class="text-danger"><app-validation class="w-100" [object]="hasGuestAgeAcknowledged" isRequired=true></app-validation></small>
                    </div>
                </div>
            </article>
                <!-- child birthdate -->
                <!-- Child Pass 16-20 -->
                <app-date *ngIf="guest.PAXTypeNo === 32 && !isRegComplete" [participant]="guest" fieldName="BirthDate" [submitted]="isError"
                label="copy.label.TRAVEL.birthdate" [isRequired]="true" [minDate]="minChildDate1" [maxDate]="maxChildDate1"></app-date>

                <!-- Child 11-15 -->
                <app-date *ngIf="guest.PAXTypeNo === 36 && !isRegComplete" [participant]="guest" fieldName="BirthDate" [submitted]="isError"
                label="copy.label.TRAVEL.birthdate" required [isRequired]="true" [minDate]="minChildDate2" [maxDate]="maxChildDate2"></app-date>

                <!-- Child 10 and under -->
                <app-date *ngIf="guest.PAXTypeNo === 37 && !isRegComplete" [participant]="guest" fieldName="BirthDate" [submitted]="isError"
                label="copy.label.TRAVEL.birthdate" required [isRequired]="true" [minDate]="minChildDate3" [maxDate]="maxChildDate3"></app-date>

                <app-guest-variables [guest]="guest" name="guestVars_{{guest.$mtcUUID}}"></app-guest-variables>
            </mat-expansion-panel>

            <div *ngIf="isAddGuestEnabled() && !isRegComplete" class="mt-2">
                <button type="button" (click)="addGuest({})"
                    class="btn btn-primary customSuccess">{{'copy.label.GUEST.GUESTFORM.add'|copy|async}}
                </button>
            </div>

        </mat-accordion>

        <div class="button_group d-flex">
            <button id="back-button" type="button" class="back btn btn-outline-primary" (click)="back()"
                *ngIf="!isSubmitting">
                <!-- <i class="material-symbols-outlined icon-align">chevron_left</i> -->
                {{ 'copy.label.GLOBAL.goback' | copy | async }}
            </button>
            <button id="forward-button" type="submit" class="inputSubmit btn btn-primary" *ngIf="!isSubmitting">
                {{ 'copy.label.GLOBAL.continue' | copy | async }}
                <!-- <i class="material-symbols-outlined icon-align">chevron_right</i> -->
            </button>
            <button class="inputSubmit btn btn-primary ms-auto" *ngIf="isSubmitting">
                <i class="fas fa-spinner fa-spin"></i>
            </button>
        </div>
    </form>
</div>
